import type { AdaptiveSettings, PatientAdaptiveSettings } from '../types/AdaptiveSettings';
import type { DoseConstraintsGlobalTemplate } from '../types/Dicom';
import { createReducerBuilder } from './utils/createReducerBuilder.ts';

export interface DoseReduxState {
  patientAdaptiveSettings?: PatientAdaptiveSettings[];
  adaptiveSettings?: AdaptiveSettings[];
  constraintTypes?: string[];
  globalConstraintTemplates?: DoseConstraintsGlobalTemplate[];
}

export const DoseAction = {
  UpdateAdaptiveSettings: 'UpdateAdaptiveSettings',
  UpdatePatientAdaptiveSettings: 'UpdatePatientAdaptiveSettings',
  UpdateConstraintTypes: 'UpdateConstraintTypes',
  UpdateGlobalConstraintTemplates: 'UpdateGlobalConstraintTemplates'
} as const;

export type DoseAction = ValueOf<typeof DoseAction>;

export const {
  dose, adaptiveSettingsSelector, updateAdaptiveSettings, updateConstraintTypes, constraintTypesSelector,
  updateGlobalConstraintTemplates, globalConstraintTemplatesSelector, updatePatientAdaptiveSettings, patientAdaptiveSettingsSelector
} = createReducerBuilder<DoseAction, 'dose', DoseReduxState>('dose')
  .add(DoseAction.UpdatePatientAdaptiveSettings, 'patientAdaptiveSettings', undefined as (PatientAdaptiveSettings[] | undefined))
  .add(DoseAction.UpdateAdaptiveSettings, 'adaptiveSettings', undefined as (AdaptiveSettings[] | undefined))
  .add(DoseAction.UpdateConstraintTypes, 'constraintTypes', undefined as (string[] | undefined))
  .add(DoseAction.UpdateGlobalConstraintTemplates, 'globalConstraintTemplates', undefined as (DoseConstraintsGlobalTemplate[] | undefined))
  .build();
